import React from "react";

function Terminal() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="terminal" className="svg-inline--fa fa-terminal fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M640 421.34v32a24 24 0 0 1-24 24H312a24 24 0 0 1-24-24v-32a24 24 0 0 1 24-24h304a24 24 0 0 1 24 24z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M29.7 464.66L7 442a24 24 0 0 1 0-33.9l154-154.76L7 98.6a24 24 0 0 1 0-33.9L29.7 42a24 24 0 0 1 33.94 0L258 236.37a24 24 0 0 1 0 33.94L63.64 464.66a24 24 0 0 1-33.94 0z"></path></g></svg>
    );
  }

export default Terminal;